import React, {useContext, useState} from 'react';
import {MenuItem} from '@material-ui/core';
import {PaymentActionType} from './PaymentActionHelper';
import MarkAsDonationDialog from '../dialogs/MarkAsDonationDialog';
import {AlertContext} from '../../../components/contexts/WithAlertContext';
import PaymentService from '../../../services/PaymentService';
import {useTranslation} from 'react-i18next';

const PaymentMarkAsDonationAction = React.forwardRef(({ payment, setMenuAnchor, label }: PaymentActionType, ref: React.Ref<any>) => {
  const [markAsDonationDialog, setMarkAsDonationDialog] = useState(false);
  const [isMarkedAsDonation, setIsMarkedAsDonation] = useState(false);
  const { t } = useTranslation('payments');
  const alerting = useContext(AlertContext);

  const markPaperlessAsDonation = () => {
    PaymentService.markPaymentAsDonation(payment).then((res) => {
      if (res) {
        setIsMarkedAsDonation(true);
        alerting.sendAlert('success', t('payments:payment marked as donation'));
        setMarkAsDonationDialog(false);
      }
    });
  };

  return !isMarkedAsDonation ? (
    <>
      <MenuItem
        ref={ref}
        key={payment.id + 'markAsDonation'}
        onClick={() => {
          setMenuAnchor(null);
          setMarkAsDonationDialog(true);
        }}
      >
        {label}
      </MenuItem>
      <MarkAsDonationDialog open={markAsDonationDialog} onCancel={() => setMarkAsDonationDialog(false)} onMarkAsDonation={markPaperlessAsDonation} />
    </>
  ) : (
    <></>
  );
});

export default PaymentMarkAsDonationAction;
